import { createSearchParams, useNavigate, useParams } from 'react-router-dom';

const useNavigateSearch = () => {
  const navigate = useNavigate();
  const { workspace } = useParams();

  return (pathname, search, options = {}) => navigate({
    pathname: `/${workspace || 0}${pathname}`,
    search: `?${createSearchParams(search)}`,
  }, options);
};

const useNavigateSearchPublic = () => {
  const navigate = useNavigate();

  return (pathname, params) => navigate({
    pathname,
    search: `?${createSearchParams(params)}`,
  });
};

const useNavigateRedirect = () => {
  const navigate = useNavigate();

  const { workspace = 0 } = useParams();
  return (pathname, options = {}) => navigate(`/${workspace}${pathname}`, options);
};

const useCreateUrl = () => {
  const { workspace = 0 } = useParams();

  return (pathname, params) => {
    const searchParams = params ? `?${createSearchParams(params)}` : '';

    return `/${workspace}${pathname}${searchParams}`;
  };
};

const navigateExternal = (url, options = {}) => {
  if (options.state) {
    localStorage.setItem('navigateState', JSON.stringify(options.state));
  }

  window.open(url, '_blank', 'noopener,noreferrer');
};

export {
  useCreateUrl,
  navigateExternal,
  useNavigateSearch,
  useNavigateRedirect,
  useNavigateSearchPublic,
};
